<app-loading-spinner *ngIf="appService.isLoading"></app-loading-spinner>

<div class="rate-table-area body-data" *ngIf="displayedColumns">
  @if (isLandingPage) {
    <div class="title" style="width: 300px;left: 14px;">Rate Agreement <span *ngIf="appService.mineBtnEbaled">(TPO buyer)</span></div>
  }
  <div class="btn-area">
    
    <div class="left-area">
      <button [ngClass]="!appService.mineBtnEbaled?'red-white-btn':'white-red-btn'" class="all-btn" (click)="onAllAndMinSelection(false)">All <span *ngIf="!appService.mineBtnEbaled">({{this.dataSource.data.length}})</span></button>
      <button [ngClass]="appService.mineBtnEbaled?'red-white-btn':'white-red-btn'" class=" mine-btn" (click)="onAllAndMinSelection(true)">Mine <span *ngIf="appService.mineBtnEbaled">({{this.dataSource.data.length}})</span></button>
    </div>

    <div class="right-area">
      @if (isLandingPage) {
        <button class="red-white-btn" (click)="onViewAllCall()">View All</button>
      }
      @else {
        <button class="red-white-btn" *ngIf="userData.RoleID===4" (click)="onViewEditItem('add', null, 'RateAgreementID')">+ Add Rate Agreement</button>
      }
      <p class="vertical-line"></p>
      <button class="white-red-btn" (click)="tableService.onReset(this, 'rate-agreement');tableService.onResetDate();resetDateFilter()">Reset Filters</button>
      <div class="search-area">
        <input type='text' class="search-input" #searchInput (keyup)="tableService.searchApplyFilter($event.target, this)" name="search"
          placeholder="Search" />
      </div>
      <p class="vertical-line"></p>
      <img (click)="tableService.onCustomColmn('RateAgreement',displayedColumns,this)" class="setting-icon icons" src="../../../../assets/images/setting-table-icon.png"
        alt="Profile Picture">
      <img (click)="onFileDownload()" [ngClass]="{'clickable': tableService.disablingDownload(this), 'non-clickable': !tableService.disablingDownload(this)}" class="download-icon icons" src="../../../../assets/images/download-icon.png"
        alt="Profile Picture">
    </div>
  </div>
  <hr>
  <ng-container class="table-container">
  <div class="mat-table-area mat-elevation-z8 table-scroll">
    <table mat-table [dataSource]="dataSource" [formGroup]="contactTableForm" matSort
      (matSortChange)="tableService.announceSortChange(this,$event,'RateAgreementStatus')" class="mat-elevation-z8">

      @for (i of displayedColumns; track i; let ind=$index) {
      @if (i.name === 'Selected') {
      <ng-container matColumnDef={{i.name}}>
        <th mat-header-cell *matHeaderCellDef style="width: 5%;">
          <div style="display: inline-flex;">
            <input type="checkbox" id="all" name="all" style="left: 3px;" [checked]="allSelected" 
            (change)="tableService.selectAllItem(this)">
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          <div style="display: inline-flex;">
              <input type="checkbox" id={{element.RateAgreementID}} name={{element.RateAgreementID}} 
              (change)="tableService.selectItem($event.target,this,'rate-agreement')" [checked]="element.Selected">
          <!-- <label class="list-name" for={{element.RateAgreementID}}>{{element.RateAgreementID}}</label> -->
          </div> 
        </td>
      </ng-container>
      }
      @else if(i.name === "RateAgreementStatus"){
      <ng-container matColumnDef={{i.name}}>
        <th class="scrollable status" mat-header-cell *matHeaderCellDef>
          <div mat-sort-header>{{i.label}}</div>
          <div style="width: 80px;">
            <mat-select class="form-field"  formControlName="RateAgreementStatusFilter" multiple="true">
              <mat-option class="option-items"
                *ngFor='let status of ["Draft", "Active", "Expired", "Terminated", "Obsolete", "Draft Obsolete"]'
                [value]="status">
                {{ status }}
              </mat-option>
            </mat-select>

          </div>
        </th>
        <td class="scrollable" mat-cell *matCellDef="let element"> {{element[i.name]}} </td>
      </ng-container>
      }
      @else if((i.name === 'FuelEscalator')||(i.name === 'AutoExtensionFlag')){
      <ng-container matColumnDef={{i.name}}>
        <th class="scrollable" mat-header-cell *matHeaderCellDef>
          <div mat-sort-header>{{i.label}}</div>
          <div style="width: 60px;">
            <mat-select class="form-field" [formControlName]="i.name+'Filter'">
              <mat-option class="option-items" *ngFor='let status of ["all","yes", "no"]' [value]="status">
                {{ status }}
              </mat-option>
            </mat-select>

          </div>
        </th>
        <td class="scrollable" mat-cell *matCellDef="let element"> {{element[i.name]}} </td>
      </ng-container>
      }
      @else if((i.name === "ModifiedOn")){
      <ng-container matColumnDef={{i.name}}>
        <th class="scrollable" mat-header-cell *matHeaderCellDef>
          <div mat-sort-header>{{i.label}}</div>
          <div style="width: 90px;position: relative;"> 
             <input type="text" matInput class="form-field dateFilter" placeholder="DD/MM/YYYY" style="font-size: 10px;padding-left: 2px;" id="{{i.name}}" readonly  
             [matDatepicker]="modifiedDatePckr" [value]="modifiedOnDate"  (click)="tableService.matDatePicker(modifiedDatePckr,i.name)" (dateChange)="onDateChange($event, i.name)"/> 
             <mat-datepicker #modifiedDatePckr></mat-datepicker>
          </div>
        </th>
        <td class="scrollable" mat-cell *matCellDef="let element"> {{tableService.checkOnInvalidDate(element[i.name])}} </td> 
      </ng-container>
      }
      @else if((i.name === "CreatedOn")){
        <ng-container matColumnDef={{i.name}}>
          <th class="scrollable" mat-header-cell *matHeaderCellDef>
            <div mat-sort-header>{{i.label}}</div>
            <div style="width: 90px;position: relative;"> 
               <input type="text" matInput class="form-field dateFilter" placeholder="DD/MM/YYYY" style="font-size: 10px;padding-left: 2px;" id="{{i.name}}" readonly  
               [matDatepicker]="createdDatePckr"  [value]="createdOnDate"  (click)="tableService.matDatePicker(createdDatePckr,i.name)" (dateChange)="onDateChange($event, i.name)"/> 
               <mat-datepicker #createdDatePckr></mat-datepicker>
            </div>
          </th>
          <td class="scrollable" mat-cell *matCellDef="let element"> {{tableService.checkOnInvalidDate(element[i.name])}} </td> 
        </ng-container>
        }
      @else if((i.name === 'EffectiveDate')){
        <ng-container matColumnDef={{i.name}}>
          <th class="scrollable" mat-header-cell *matHeaderCellDef>
            <div mat-sort-header>{{i.label}}</div>
            <div style="font-size: 10px;padding-left: 2px;width: 120px;"> 
              <input type="text"class="form-field dateFilter" placeholder="DD/MM/YYYY" style="font-size: 10px;padding-left: 2px;" id="{{i.name}}" readonly [value]="EffectiveDateRange" (click)="toggleDatePicker(i.name)" />
                <ngx-daterangepicker-material *ngIf="activePicker === i.name" id="effectivedatefilter"  class="form-control effective" [locale]="{ format: 'DD/MM/YYYY' }"
                  [autoApply]="true" [showDropdowns]="true"(datesUpdated)="onDatesUpdated(i.name,$event, 'EffectiveDate')"
                  (cancelClicked)="toggleDatePicker(i.name, false)"></ngx-daterangepicker-material>
            </div>
          </th>
          <td class="scrollable" mat-cell *matCellDef="let element"> {{tableService.checkOnInvalidDate(element[i.name], true)}} </td> 
        </ng-container>
      }
      @else if((i.name === 'ExpiryDate')){
        <ng-container matColumnDef={{i.name}}>
          <th class="scrollable" mat-header-cell *matHeaderCellDef>
            <div mat-sort-header>{{i.label}}</div>
            <div style="font-size: 10px;padding-left: 2px;width: 120px;"> 
              <input type="text"class="form-field dateFilter" placeholder="DD/MM/YYYY" style="font-size: 10px;padding-left: 2px;" id="{{i.name}}" readonly [value]="ExpiryDateRange" (click)="toggleDatePicker(i.name)" />
                <ngx-daterangepicker-material *ngIf="activePicker === i.name" id="expritydatefilter" class="form-control expiry" [locale]="{ format: 'DD/MM/YYYY' }"
                  [autoApply]="true" [showDropdowns]="true"(datesUpdated)="onDatesUpdated(i.name,$event, 'ExpiryDate')"
                  (cancelClicked)="toggleDatePicker(i.name, false)"></ngx-daterangepicker-material>
            </div>
          </th>
          <td class="scrollable" mat-cell *matCellDef="let element"> {{tableService.checkOnInvalidDate(element[i.name], true)}} </td> 
        </ng-container>
      }
      @else if((i.name === 'InitialContractEffectiveDate')){
        <ng-container matColumnDef={{i.name}}>
          <th class="scrollable" mat-header-cell *matHeaderCellDef>
            <div mat-sort-header>{{i.label}}</div>
            <div style="width: 90px;"> 
              <input type="text" matInput class="form-field dateFilter" placeholder="DD/MM/YYYY" style="font-size: 10px;padding-left: 2px;" id="{{i.name}}" readonly  
               [matDatepicker]="ContractEffectiveDatePckr" [value]="intialDateValue" (click)="tableService.matDatePicker(ContractEffectiveDatePckr,i.name)" (dateChange)="onDateChange($event, i.name)"/> 
               <mat-datepicker #ContractEffectiveDatePckr></mat-datepicker>
            </div>
          </th>
          <td class="scrollable" mat-cell *matCellDef="let element"> {{tableService.checkOnInvalidDate(element[i.name], true)}} </td> 
        </ng-container>
        }
      @else if(i.name === 'alert'){
      <ng-container matColumnDef={{i.name}}>
        <th class="scrollable" mat-header-cell *matHeaderCellDef>
          <div mat-sort-header>{{i.label}}</div>
          <div style="width: 60px;">
            <mat-select class="form-field"  [formControlName]="i.name+'Filter'">
              <mat-option class="option-items"
                *ngFor='let status of ["all","blank", "due for auto extension", "due to termination"]' [value]="status">
                {{ status }}
              </mat-option>
            </mat-select>

          </div>
        </th>
        <td class="scrollable" mat-cell *matCellDef="let element"> {{element[i.name]}} </td>
      </ng-container>
      }

      @else if (i.name === 'action') {
      <ng-container matColumnDef='action' style="position: sticky;z-index: 10;" style="border-left: 1px solid #cccccc5c;">
        <th mat-header-cell *matHeaderCellDef class="action-atrea fixed-column" style="border-left: 1px solid #cccccc5c;" sticky> 
          <div class="action-btns">Action</div> </th>
        <td mat-cell class="action-data fixed-column" *matCellDef="let element; let ind=index" style="border-left: 1px solid #cccccc5c;">
            <div class="action-items" 
            (click)="onViewEditItem('view', element, 'RateAgreementID')"><mat-icon>visibility</mat-icon><span>View</span></div>
          <div class="action-items" style="border-left: 1px solid #CCCCCCCC;" *ngIf="userData.RoleID===4" (click)="onViewEditItem('edit', element, 'RateAgreementID')"><mat-icon>edit</mat-icon><span>Edit</span>
          </div>
        </td>
      </ng-container>
      }
      @else if(i.name === 'DescriptionofService'){
        <ng-container matColumnDef={{i.name}}>
          <th mat-header-cell class="scrollable" *matHeaderCellDef>
            <div mat-sort-header>{{i.label}}</div>
            <div style="width: 60px;">
              <input matInput class="form-field" [formControlName]="i.name+'Filter'" placeholder="Filter">
            </div>
          </th>
          <td class="scrollable" mat-cell *matCellDef="let element"> {{appService.deResingDoubleQuotess(element[i.name])}} </td>
        </ng-container>
        }
      
      @else{
      <ng-container matColumnDef={{i.name}}>
        <th mat-header-cell class="scrollable" *matHeaderCellDef>
          <div mat-sort-header>{{i.label}}</div>
          <div style="width: 60px;">
            <input matInput class="form-field" [formControlName]="i.name+'Filter'" placeholder="Filter">
          </div>
        </th>
        <td class="scrollable" mat-cell *matCellDef="let element"> {{element[i.name]}} </td>
      </ng-container>
      }
    }

      <!-- <mat-header-row *matHeaderRowDef="['action']; sticky: true"></mat-header-row>
     <mat-row *matRowDef="let row; columns: ['action'];"></mat-row> -->

      <tr mat-header-row *matHeaderRowDef="dataColList"></tr>
      <tr mat-row *matRowDef="let row; columns: dataColList"></tr>
    </table>
    <hr style="width: 100%;">
    <div class="table-footer">
      <span></span>
      <!-- <span style="color: #666666; font-size: 12px;">(Showing {{getCurrentRecordCount()}} out of {{ dataSource.data.length }} results)</span> -->
      <div style="display: flex;">
        <mat-paginator [pageSizeOptions]="[1, 5, 10, 20]" [pageSize]="pageSize" [length]="totalRecord" (page)="tableService.onPageChange($event,this,'rateTable')" showFirstLastButtons aria-label="Select page of periodic elements">
        </mat-paginator>
        <div class="gotoArea">
          <span style="color: #666666;">Go to page</span>
          <input type="number" style="width: 40px;padding: 0px;text-align: center;font-size: 14px;color: #666666;"  [(ngModel)]="goToPageNumber">
          <div style="font-weight:500; margin-right:4px"> / {{getPageCount()}}</div>
          <button style="min-width: 40px;font-weight: 900;" class="white-red-btn" (click)="tableService.goToPage(this)">Go</button>
        </div>
      </div>
      
    </div>
   
  </div>
</ng-container>
</div>